import React from 'react';
import { ImageWithPlaceholder } from '@hpstellar/core';
import './badges-with-award.less';

export default ({ className, badges = [] }) => {
    if (!badges || badges.length === 0) {
        return null;
    }

    return (
        <div className="award-logos-container">
            <div className={className}>
                {badges.map(item => (
                    <ImageWithPlaceholder src={item.imageUrl} alt={item.imgAlt} />
                ))}
            </div>
        </div>
    );
};
